// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export const supportedSignatureAlgorithms = [
    "RS256",
    "RS384",
    "RS512",
];
